import { memo } from "react";
import { useInitialURLBootstrap } from "@/hooks/useInitialURLBootstrap/useInitialURLBootstrap";
import { useURLToStore } from "@/hooks/useURLToStore/useURLToStore";

/**
 * URLBootstrap
 *
 * A renderless component that wires up the new URL-driven selection flow:
 *
 *  1. `useInitialURLBootstrap` — fires once after bootstrap data is ready;
 *     parses the current URL and dispatches `setPendingSelection` so the
 *     RTK selectionListener can validate + commit the initial selection.
 *
 *  2. `useURLToStore` — reacts to every subsequent location change (i.e.
 *     after the listener calls `navigateTo`) and calls `syncFromURL` to keep
 *     `userSelection` in sync with the clean URL.
 *
 * Must be rendered inside the Router tree.
 */
const URLBootstrap: React.FC = () => {
  useInitialURLBootstrap();
  useURLToStore();
  return null;
};

export default memo(URLBootstrap);